import * as React from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
// import { green } from "@mui/material/colors";
import Button from "@mui/material/Button";
import Fab from "@mui/material/Fab";
import DoneOutlineIcon from "@mui/icons-material/DoneOutline";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import "./SuccessAcceptCSS.css";

export default function SuccessAccept({ responsevendordata }) {
  const [loading, setLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const timer = React.useRef(undefined);

  const buttonSx = {
    ...(success && {
      bgcolor: responsevendordata.statusbg,
      "&:hover": {
        bgcolor: responsevendordata.statusbg,
      },
    }),
  };

  React.useEffect(() => {
    setSuccess(false);
    setLoading(true);
    timer.current = setTimeout(() => {
      setSuccess(true);
      setLoading(false);
    }, 2000);

    return () => {
      clearTimeout(timer.current);
    };
  }, []);

  // const handleButtonClick = () => {
  //   if (!loading) {
  //     setSuccess(false);
  //     setLoading(true);
  //     timer.current = setTimeout(() => {
  //       setSuccess(true);
  //       setLoading(false);
  //     }, 2000);
  //   }
  // };

  function checkresulticon(responsevendordata) {
    let resultiocn = "";
    if (responsevendordata.statuid === "102") {
      resultiocn = <DoneOutlineIcon />;
    } else {
      resultiocn = <CloseIcon />;
    }
    return resultiocn;
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        marginBottom: "20px",
      }}
    >
      <Box sx={{ m: 1, position: "relative" }}>
        <Fab aria-label="save" sx={buttonSx} className="vendorRequestBTN">
          {success ? checkresulticon(responsevendordata) : <SaveIcon />}
        </Fab>
        {loading && (
          <CircularProgress
            size={90}
            sx={{
              color: responsevendordata.statusbg,
              position: "absolute",
              top: -6,
              left: -6,
              zIndex: 1,
            }}
          />
        )}
      </Box>
      <Box sx={{ m: 1, position: "relative" }}>
        <Button
          variant="contained"
          sx={buttonSx}
          disabled={loading}
          width={100}
        >
          Your request is{" "}
          <span className="mx-1 fw-700">{responsevendordata.statusname}</span>
          with the admin
        </Button>
        {loading && (
          <CircularProgress
            size={24}
            sx={{
              color: responsevendordata.statusbg,
              position: "absolute",
              top: "50%",
              left: "50%",
              marginTop: "-12px",
              marginLeft: "-12px",
            }}
          />
        )}
      </Box>
      {responsevendordata.reasion && (
        <p>
          <b>Reasion : </b> {responsevendordata.reasion}
        </p>
      )}
    </Box>
  );
}
